"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getLatLng;
var _lodash = require("lodash");
function getLatLng() {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return address.lat_lng !== undefined ? (0, _lodash.get)(address, 'lat_lng', []) : [(0, _lodash.get)(address, 'latitude', []), (0, _lodash.get)(address, 'longitude', [])];
}